package com.milta.feature.packagelabelscan.data.repository

import com.milta.feature.packagelabelscan.data.remote.PackageLabelScanApi
import com.milta.feature.packagelabelscan.data.remote.dto.toDomain
import com.milta.feature.packagelabelscan.domain.entity.PackageLabelScanResult
import com.milta.feature.packagelabelscan.domain.repository.PackageLabelScanRepository

class PackageLabelScanRepositoryImpl(private val api: PackageLabelScanApi) : PackageLabelScanRepository {
    override suspend fun scanLabel(fileBytes: ByteArray, fileName: String): PackageLabelScanResult =
        api.scanLabel(fileBytes, fileName).toDomain()
}
